export const styledQueueingTime = {
    '& time': {
        fontSize: '$sidebarQueueingTimeText',
        marginLeft: '$sidebarQueueingTimeMarginHorizontal',
    },
    'alignItems': 'center',
    'backgroundColor': '$timerNormalBackground',
    'borderRadius': '10px',
    'color': '$timerNormalText',
    'display': 'flex',
    'fontWeight': 700,
    'height': '20px',
    'padding': '0 6px',
    'variants': {
        slaState: {
            normal: {
                backgroundColor: '$timerNormalBackground',
                color: '$timerNormalText',
            },
            reminder: {
                backgroundColor: '$timerReminderBackground',
                color: '$timerReminderText',
            },
            warning: {
                backgroundColor: '$timerWarningBackground',
                color: '$timerWarningText',
            },
        },
        variant: {
            button: {
                '& time': {
                    fontSize: '12px',
                    marginLeft: 0,
                },
            },
            sidebar: {
                '& time': {
                    fontSize: '$sidebarQueueingTimeText',
                    marginLeft: 0,
                },
            },
        },
    },
}
